export const REGO_SERVICE_POPUP = {
    REGO_CHARGES: "REGO_CHARGES",
    REGO_CHARGES_LEARN_MORE: "REGO_CHARGES_LEARN_MORE",
    REMOVAL_FLOW: "REMOVAL_FLOW"
};
